import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  SignUpJoin,
} from '#features/auth/invite/SignUpJoin';
import {
  inviteTokenSearchSchema,
} from '#src/types/inviteToken';
export const Route = createFileRoute('/_app/invite/new')({
  component: SignUpJoin,
  validateSearch: inviteTokenSearchSchema,
});
